/**
 * 全局对象
 */
function getGlobalObject() {
  if (typeof globalThis !== 'undefined') {
    // globalThis 视环境支持
    return globalThis;
  }
  if (typeof self !== 'undefined') {
    return self;
  }
  if (typeof window !== 'undefined') {
    return window;
  }
  if (typeof global !== 'undefined') {
    return global;
  }

  return {};
}

// 全局对象
export const globalObject = getGlobalObject();

/**
 * 运行上下文，如果是 SSR 直出时，返回的是 SSR_CONTEXT
 * @returns
 */
function getGlobalContext() {
  if (typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
    return __VUE_SSR_CONTEXT__;
  }
  return globalObject;
}

// 运行上下文，如果是 SSR 直出时，返回的是 SSR_CONTEXT
export const globalContext = getGlobalContext();

/**
 * 获取系统 UserAgent
 * @returns {String}
 */
export function getUserAgent() {
  return globalContext?.navigator?.userAgent || '';
}

export function getLocation() {
  return globalContext?.location || {};
}

export default {
  globalObject,
  document: globalObject?.document || {},
};
